import styled from 'styled-components';
import * as variables from './../../../assets/css/variables';

export const FormGroup = styled.div`
    width: 15rem;
    height: 3.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1pt solid ${({checked}) => checked ? variables.COLOR_BLUE : '#D3D3D3'};
    border-radius: 16rem;
    background-color: ${({checked}) => checked ? variables.COLOR_BLUE : '#FFF'};
    
    input {
        width: 1px !important;
        height: 1px !important;
    }
    
    label {
        border-radius: 16rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 !important;
        padding: 0 !important;
        color: ${({checked}) => checked ? '#FFF' : '#000'} !important;
        
        :before, :after {
            display: none;
        }
    }
    
    @media (max-width: ${variables.TABLET}) {
        width: 11rem;
        height: 2.4285714285714284rem;
    }
    
    @media (max-width: ${variables.MOBILE}) {
        width: 9rem;
        height: 2.4285714285714284rem;
    }
`;